module.exports = "/images/vendor/flag-icon-css/flags/1x1/va.svg?90e9f73abaa206455171084b6475ca69";